export class OrderTransportConstant {
  static CREATED = "CREATED";
  static ASSIGNED = "ASSIGNED";
  static PENDING_RESTITUTION = "PENDING_RESTITUTION";
  static RESTITUE = "RESTITUE";
}
